// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dhEG","col":"styles_col__30Aa0"};